import styled from 'styled-components';

const FloatedToolBar = styled.div`
  position: absolute;
  min-width: ${props => props.minWidth}px;
  z-index: 1015;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  margin-top: -6px;
  background-color: ${props => props.theme.color.wfBlack};
  border-radius: ${props => props.borderRadius}px;
  height: 46px;
  padding: 0px 20px;
  transition: opacity 0.75s;
  width: ${props => props.width};
`;

const FixedToolBar = styled.div(
  ({ theme, width, borderRadius, minWidth, top, left }) => {
    return {
      borderBottom: `1px solid ${theme.color.wfGrey50}`,
      padding: `${theme.space[1]} ${theme.space[3]}`,
      backgroundColor: theme.color.wfWhite,
      justifyContent: 'flex-start',
      transition: 'opacity 0.75s',
      boxSizing: 'border-box',
      alignItems: 'center',
      display: 'flex',
      height: 36,
      zIndex: 1015,
      borderRadius,
      minWidth,
      top,
      left,
      width,
    };
  },
);

export { FloatedToolBar, FixedToolBar };
